import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [scrolled, setScrolled] = useState(!isHomePage);

  useEffect(() => {
    if (!isHomePage) {
      setScrolled(true);
      return;
    }
    const handleScroll = () => setScrolled(window.scrollY > 50);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  return (
    <header
      className={`fixed top-0 w-full text-white z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-navy/85 backdrop-blur-sm shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto max-w-7xl flex items-center justify-between py-0 px-4">
        {/* logo */}
        <Link to="/#hero" onClick={() => setOpen(false)}>
          <img
            src="/imagem/logo-horizontal.png"
            alt="AEAGO"
            className="h-16 lg:h-20 xl:h-24 w-auto"
          />
        </Link>

        {/* mobile toggle */}
        <button
          className="xl:hidden p-2 focus:outline-none"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          <svg
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {open ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* navigation menu */}
        <nav
          className={`flex-1 xl:flex xl:justify-end xl:items-center xl:w-auto ${
            open
              ? 'block absolute left-0 top-full bg-navy/90 backdrop-blur-sm z-40 py-4 w-full'
              : 'hidden'
          }`}
        >
          <ul className="xl:flex justify-end space-x-3 w-full items-center">
            {[
              ['Inicio', '/#hero'],
              ['Sobre', '/#about'],
              ['Cursos', '/#cursos'],
              ['Notícias', '/#noticias'],
              ['Revista', '/#revista-inova-agro'],
              ['Eventos', '/#eventos'],
              ['Contato', '/#contato'],
              ['Convênios', '/#convenios'],
              ['Associe-se', '/#associe-se'],
            ].map(([label, to]) => (
              <li key={to} className="xl:my-0 my-2">
                <Link
                  to={to}
                  className="block text-white hover:text-secondary font-semibold px-2 py-1 rounded-full"
                  onClick={() => setOpen(false)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;